export default __webpack_public_path__ + "static/media/Smiling.6fad3e85.png";